import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axiosInstances";
import { GlobalReport } from "@prisma/client";

const getGlobalReport = async () => {
  const { data } = await privateAxios.get<GlobalReport | null>(
    "/global-report"
  );
  return data;
};

export const useGetGlobalReportQuery = () => {
  return useQuery({
    queryKey: ["global-report"],
    queryFn: getGlobalReport,
  });
};
